import { render, staticRenderFns } from "./shareBlack.vue?vue&type=template&id=76a5883e&scoped=true"
import script from "./shareBlack.vue?vue&type=script&lang=js"
export * from "./shareBlack.vue?vue&type=script&lang=js"
import style0 from "./shareBlack.vue?vue&type=style&index=0&id=76a5883e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a5883e",
  null
  
)

export default component.exports